import 'waypoints/lib/noframework.waypoints'

export default class Waypoints {

    constructor() {

        document.querySelectorAll('[class*=so-widget]').forEach(el => {
            new Waypoint({
                element: el,
                handler: function() {
                    this.element.classList.add('widget-is-visible');
                },
                offset: '80%'
            })
        })

        document.querySelectorAll('.panel-grid').forEach(el => {
            new Waypoint({
                element: el,
                handler: function() {
                    this.element.classList.add('row-is-visible');
                },
                offset: '80%'
            })
        })

    }

}